var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 9.999a10.005 10.005 0 0 0 8.437 9.879v-6.99H5.9v-2.89h2.54v-2.2a3.528 3.528 0 0 1 3.773-3.9c.75.013 1.5.08 2.24.2v2.46h-1.264a1.446 1.446 0 0 0-1.628 1.563v1.878h2.771l-.443 2.89h-2.328v6.989A10 10 0 1 0 0 9.998"
})));
export default SvgFacebook;